export default __webpack_public_path__ + "static/media/icon-logout-m.6bec29c1.svg";